import { PencilIcon, TrashIcon } from '@heroicons/react/20/solid'

export default function PlacowkaDetailsCard({ placowka, onEdit, onDelete }) {
	const name = placowka?.nazwa || 'Placowka'

	return (
		<div className="mb-5 rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
				<div>
					<h1 className="text-lg font-semibold text-gray-900">{name}</h1>
					<p className="mt-1 text-sm text-gray-600">{placowka?.adres || '-'}</p>
				</div>
				<div className="flex flex-wrap items-center gap-2">
					<button
						type="button"
						onClick={onEdit}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100">
						<PencilIcon className="h-4 w-4" />
						<span>Edytuj</span>
					</button>
					<button
						type="button"
						onClick={onDelete}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100">
						<TrashIcon className="h-4 w-4" />
						<span>Usuń</span>
					</button>
				</div>
			</div>
			<dl className="mt-4 grid grid-cols-1 gap-3 border-t border-gray-100 pt-4 text-sm sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Miasto</dt>
					<dd className="mt-0.5 text-gray-900">{placowka?.id_miasto?.nazwa || '-'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Gmina</dt>
					<dd className="mt-0.5 text-gray-900">{placowka?.id_gmina?.nazwa || '-'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Powiat</dt>
					<dd className="mt-0.5 text-gray-900">{placowka?.id_powiat?.nazwa || '-'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Wojewodztwo</dt>
					<dd className="mt-0.5 text-gray-900">{placowka?.id_wojewodztwo?.nazwa || '-'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Typ</dt>
					<dd className="mt-0.5 text-gray-900">{placowka?.id_typ?.typ || '-'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">NIP</dt>
					<dd className="mt-0.5 text-gray-900">{placowka?.nip || '-'}</dd>
				</div>
			</dl>
		</div>
	)
}
